export default __webpack_public_path__ + "static/media/Zoom +.d35727a7.svg";